import { isLocalhost } from './isLocalHost';

export const baseApiUrl = isLocalhost
  ? `${process.env.REACT_APP_API_URL}/api`
  : '/api';
